import React, { useEffect, useState } from 'react';
import '~/styles/testimonial-slider.css';

type Review = {
  name: string;
  content: string;
  stars: number;
};

type Props = {
  heading: string;
  reviews: Review[];
};


const chunkArray = (arr: Review[], size: number): Review[][] => {
  const result: Review[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};


export const TestimonialsSlider: React.FC<Props> = ({ heading, reviews }) => {
  const [groupedTestimonials, setGroupedTestimonials] = useState<Review[][]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      const chunkSize = isMobile ? 1 : 2;
      setGroupedTestimonials(chunkArray(reviews, chunkSize));
      setCurrentSlide(0); // Optional: reset to first slide
    };

    if (typeof window !== 'undefined') {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };

  }, [reviews]);
  

  console.log('reviews : ', reviews);
  
  const handlePrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? groupedTestimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === groupedTestimonials.length - 1 ? 0 : prev + 1));
  };

  if (!groupedTestimonials.length) return null;

  return (
    <>
    <div className="w-full mx-auto px-4 sm:px-6 max-w-[100%] md:max-w-[95%] lg:max-w-[1200px] pt-testimonial-sliders-data">
      <div className='flex  justify-center sm:justify-between pt-testimonial-container order-2 md:order-1 mb-4 md:mb-0'>
        <h2 className="pt-testimonial-heading">{heading}</h2>
        <div className="flex gap-4">
          <button onClick={handlePrev} className="pt-button w-10 h-10 bg-[#3B82F6] text-white rounded-full flex items-center justify-center"> ‹ </button>
          <button onClick={handleNext} className="pt-button w-10 h-10 bg-[#3B82F6] text-white rounded-full flex items-center justify-center"> › </button>
        </div>
      </div>
          
      <div className="relative max-w-7xl mx-auto order-1 md:order-2">
        <div className="slider-wrapper relative min-h-[250px]">

          
          <div className="w-full overflow-x-auto flex flex-row gap-10 scrollbar-hide transition-opacity duration-700 ease-in-out">
            {groupedTestimonials[currentSlide]?.map((item, index) => (
              <div key={index} className="custom-slide min-w-[360px]">
                <div className="text-yellow-400 text-xl mb-4 pt-testimonial-stars">
                  {'★'.repeat(item.stars)}
                </div>
                <p className="text-gray-700 mb-6 pt-testimonial-content">{item.content}</p>
                <p className="text-[#3B82F6] font-bold pt-testimonial-name">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
        {/* Dots */}
        <div className="flex justify-center mt-6 gap-2">
          {groupedTestimonials.map((_, idx) => (
            <span
              key={idx}
              className={`dot ${idx === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(idx)}
            />
          ))}
        </div>
      </div>
    </div>  
    </>
  );
};
